// src/lib/stack-app/common.ts
var stackAppInternalsSymbol = Symbol.for("StackAuth--DO-NOT-USE-OR-YOU-WILL-BE-FIRED--StackAppInternals");
export {
  stackAppInternalsSymbol
};
//# sourceMappingURL=common.js.map